

function initAnimations() {
  //console.log('init animations')

  var controller = new ScrollMagic.Controller();

  /*
  var tl = new TimelineLite({delay: 1}),
    firstBg = document.querySelectorAll('.animate-reveal__first-bg'),
    secBg = document.querySelectorAll('.animate-reveal__second-bg'),
    word  = document.querySelectorAll('.animate-reveal__word'),
    text = document.querySelectorAll('.animate-reveal__summary');

  tl
    .to(firstBg, 0.2, {scaleX:1})
    .to(secBg, 0.2, {scaleX:1})
    .to(word, 0.1, {opacity:1}, "-=0.1")
    .to(firstBg, 0.2, {scaleX:0})
    .to(secBg, 0.2, {scaleX:0})
    .to(text, 0.5, {opacity: 1, y:0});*/

  //document.querySelector('.restart').onclick = function() {tl.restart()};

  var toAnimate = document.querySelectorAll('.animate');

  for (var i = 0; i < toAnimate.length; i++) {
    var curr = toAnimate[i];
    var activeClass = curr.dataset.activeClass;
    //console.log(curr.id);

    /*var toggleClasses = TweenMax.set(
      '#' + curr.id , { className : 'animated ' + animation }
    );*/

    new ScrollMagic.Scene({
  		triggerElement: '#' + curr.id,
  		triggerHook: 0.8, // show, when scrolled 10% into view
  		//duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
  		//offset: 50 // move trigger to center of element
  	})
  	.setClassToggle('#' + curr.id, activeClass) // add class to reveal
    //.setTween(toggleClasses)
    .reverse(false)
  	.addTo(controller);
  }


  var toAnimate = document.querySelectorAll('.animate-parallax');

  for (var i = 0; i < toAnimate.length; i++) {
    var curr = toAnimate[i];
    //console.log(curr);

    new ScrollMagic.Scene({
  		triggerElement: '#' + curr.id,
      duration: "200%",
      triggerHook: 1
  	})
  	.setClassToggle('#' + curr.id, 'animate-parallax--active') // add class to reveal
    .setTween('#' + curr.id + ' > .animate-parallax__image', {y: "80%", ease: Linear.easeNone})
  	.addTo(controller);

    var image = document.querySelector('#' + curr.id + ' > div');
    image.addEventListener('transitionend', function() {
      //console.log('Transition ended');

      //image.style.transition = 'none';
    });
  }



  /*
    var scene = new ScrollMagic.Scene({
  		triggerElement: "#home-intro"
  	})
  	.setTween("#home-intro .lead-in", 0.5, {top: "0", opacity: "1", delay: 1.75}) // trigger a TweenMax.to tween
  	//.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
  	.addTo(controller);
  */


/*
  new ScrollMagic.Scene({triggerElement: "#parallax1"})
			.setTween("#parallax1 > div", {y: "80%", ease: Linear.easeNone})
			.addTo(controller);*/



/*
  var setMultipleClasses = TweenMax.set(document.querySelector("#home-intro .lead-in"), {
    className: "lead-in animated fadeInDown delay-2s "
  });

	new ScrollMagic.Scene({
		triggerElement: "#home-intro",
		triggerHook: 0.5, // show, when scrolled 10% into view
		//duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
		offset: 50 // move trigger to center of element
	})
  //.setTween("#home-intro", 0.5, {backgroundColor: "green", scale: 2.5, delay: 2})
	//.setClassToggle(document.querySelector("#home-intro .lead-in"), "animated") // add class to reveal
  .setTween(setMultipleClasses)
	.addTo(controller);*/

/*
  new ScrollMagic.Scene({
		triggerElement: ".animate-in",
		triggerHook: 0.7, // show, when scrolled 10% into view
	//	duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
		offset: 50 // move trigger to center of element
	})
	.setClassToggle(".animate-in", "animate-in--active") // add class to reveal
	.addTo(controller);*/


  /*
  new ScrollMagic.Scene({
		triggerElement: ".animate-text-image",
		triggerHook: 0.7, // show, when scrolled 10% into view
	//	duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
		offset: 50 // move trigger to center of element
	})
	.setClassToggle(".animate-text-image", "animate-text-image--active") // add class to reveal
	.addTo(controller);*/

  /*new ScrollMagic.Scene({
		triggerElement: ".animate-css",
		triggerHook: 0.7, // show, when scrolled 10% into view
		duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
		offset: 50 // move trigger to center of element
	})
  .on('start', function () {
      console.log('start');

      var elem = this.triggerElement();
      var animation = elem.dataset.animation;

      elem.classList.add('animated', animation);
  })
  .on('end', function () {
      console.log('stop');

      var elem = this.triggerElement();
      var animation = elem.dataset.animation;

      elem.classList.remove('animated', animation);
  })
	//.setClassToggle(".animate", "animated") // add class to reveal
	.addTo(controller);*/

}


export default function animations() {

  initAnimations();


  //if (page == 'animation-test') {
    //console.log(page);

  //}
}
